import { configureStore, createSlice } from '@reduxjs/toolkit';
import { getStoredUser, setStoredUser } from '../api/http';

/* Globalni state: ulogovan korisnik i keš šifarnika (kompanije, marke/modeli). Ekranski state
   (izbor vozača, datumi, nesačuvane izmene) ostaje lokalan i preživljava navigaciju kroz KeepAlive. */

const authSlice = createSlice({
    name: 'auth',
    initialState: { user: getStoredUser() },
    reducers: {
        setUser: (s, a) => { s.user = a.payload; },
    },
});

const NO_COMPANY = { id: null, name: 'Bez kompanije' };

const companiesSlice = createSlice({
    name: 'companies',
    initialState: { list: [], loaded: false },
    reducers: {
        setCompanies: (s, a) => { s.list = a.payload; s.loaded = true; },
    },
});

export const { setUser } = authSlice.actions;
export const { setCompanies } = companiesSlice.actions;
export { NO_COMPANY };

export const store = configureStore({
    reducer: { auth: authSlice.reducer, companies: companiesSlice.reducer },
    /* kompanije sadrže Date objekte (reviver datuma) — serializableCheck bi samo bacao upozorenja */
    middleware: (getDefault) => getDefault({ serializableCheck: false }),
});

/* Korisnik se pamti van reducera (reduceri ostaju čisti). */
let lastUser = store.getState().auth.user;
store.subscribe(() => {
    const u = store.getState().auth.user;
    if (u !== lastUser) { lastUser = u; setStoredUser(u); }
});
